<div class="modal-header">
    <h3 class="modal-title" id="staticBackdropLabel">Generar Certificado DD.JJ.</h3>
    <fa-icon [icon]="['fas', 'times']" (click)="onCloseModal()" [size]="'lg'"></fa-icon>
</div>

<div class="modal-body">
    <form class="row g-3" [formGroup]="form" (ngSubmit)="GenerarPDF()">
        <div class="form-group col-7">
            <label for="region">Seleccionar Periodo</label>
            <select class="form-select" id="anio" formControlName="anio">
                <option *ngFor="let anios of aniosLov" [value]="anios.agno">{{ anios.agno }}</option>
            </select>
        </div>
        <span class="border-bottom"></span>
        <button type="submit" class="btn btn-primary col-5">Vista Previa</button>
        <div class="col-2"></div>
        <button class="btn btn-danger col-5" (click)="onCloseModal()">Cancelar</button>
    </form>
    
</div>